export {default} from './InputPhoneNumber'
